import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

// true: alla lista delle bozze; altrimenti si resta sulla proposta, ormai bozza
@Component({
  providers: [provideTranslocoScope('orders')],
  selector: 'ord-draft-saved-dialog',
  imports: [TranslocoPipe, MatButtonModule, MatDialogModule],
  template: `
    <mat-dialog-content class="draft-saved-content">
      <div class="draft-saved-icon">
        <i class="fa-solid fa-file-pen"></i>
      </div>
      <span class="title-medium-emphasized">{{ 'orders.ui.bozzaSalvata' | transloco }}</span>
      <span class="body-small">{{ 'orders.ui.laBozzaEStataSalvataCorrettamente' | transloco }}</span>
      <div class="draft-saved-name">
        <span class="body-small">{{ 'orders.ui.nomeBozza' | transloco }}</span>
        <span class="body-medium-emphasized">{{ data.name }}</span>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="draft-saved-actions">
      <button matButton="filled" type="button" [mat-dialog-close]="true">{{ 'orders.ui.vaiABozze' | transloco }}</button>
      <button matButton type="button" [mat-dialog-close]="false">{{ 'orders.ui.tornaAlDettaglio' | transloco }}</button>
    </mat-dialog-actions>
  `,
  styles: `
    .draft-saved-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--mat-sys-spacing-8);
    }

    .draft-saved-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 56px;
      height: 56px;
      border-radius: 100%;
      color: var(--mat-sys-on-surface-variant);
      background-color: var(--mat-sys-primary-container);
    }

    .draft-saved-name {
      display: flex;
      flex-direction: column;
      align-self: stretch;
      gap: var(--mat-sys-spacing-4);
      padding-top: var(--mat-sys-spacing-16);
      border-top: 1px solid var(--mat-sys-outline-variant);
    }

    .draft-saved-actions {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: var(--mat-sys-spacing-8);
    }
  `,
})
export class DraftSavedDialog {
  readonly data = inject<{ name: string | null }>(MAT_DIALOG_DATA);
}
